import { useMutationWithToaster } from "hooks";

import toGlobalId from "../../../api/helper";

const {
  createResolverFactory,
} = require("../components/FormFieldBuilder/hooks");

function mutationFactory() {
  const query = `mutation duplicateWorkflow($workflowId: ID!) {
    duplicateWorkflow(workflowId: $workflowId) {
      workflow {
        uuid
        name
        numTasks
        numActiveClients
        canEdit
        clientTileOptions {
          showProgress
          showIcons
          showStreams
          numberOfTasks
          presentWorkflowName
          presentStartDate
        }
        workflowRules {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }`;

  const resolver = ({ data: { duplicateWorkflow } }) => {
    return {
      data: {
        ...duplicateWorkflow.workflow,
        id: duplicateWorkflow.workflow.uuid,
      },
    };
  };

  return { query: query, resolver: createResolverFactory(resolver) };
}

export function useDuplicateWorkflowAction(onDone) {
  const [duplicate] = useMutationWithToaster(mutationFactory, { onDone });

  return (wfId, wfName) => {
    return duplicate(
      { workflowId: toGlobalId("Workflow", wfId) },
      {
        successMsg: `Duplicated ${wfName} successfully`,
        defaultErrorMsg: `Failed to duplicate workflow ${wfName}`,
      }
    );
  };
}

export default useDuplicateWorkflowAction;
